import { useApi } from '@/api';
import { TableSkeleton, Link } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import { DATE_MAPPING } from '@/constants';
import {
  Box,
  CryptoIcon,
  CurrencyValue,
  Flex,
  PercentageValue,
  useTableProps,
  DataTable
} from '@blockanalitica/ui';

export default function IlksTable({ daysAgo }) {
  const { pagination, sorting } = useTableProps({
    pageSize: 10,
    initialSorting: '-debt',
    filtersDebounceTime: 50
  });

  const [data, error] = useApi({
    url: '/groups/legacy-rwa/ilks/',
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting,
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }
  const date = DATE_MAPPING[daysAgo];
  if (data) {
    const columns: TableColumn[] = [
      {
        header: '',
        getCell: (row) => (
          <Flex flexDirection="column" gap="3xs">
            {row.name}
            <Box color="muted" fontSize="-1">
              {row.ilk}
            </Box>
          </Flex>
        )
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Debt
            <CryptoIcon name="DAI" size="0" />
          </Flex>
        ),

        getCell: (row) => <CurrencyValue value={row.debt} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'debt'
      },
      {
        header: `Change (${date})`,
        getCell: (row) => (
          <CurrencyValue
            value={row.debt_change}
            options={{ trend: true, iconSize: '0' }}
          />
        ),
        getCellBottom: (row) => (
          <PercentageValue
            color="muted"
            fontSize="-1"
            value={row.debt_change_percentage}
            options={{
              nullable: (
                <Box color="muted" fontSize="-1">
                  -
                </Box>
              )
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'debt_change'
      },
      {
        header: 'DC',
        getCell: (row) => <CurrencyValue value={row.line} />,

        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'line'
      },
      // {
      //   header: 'Collateral',
      //   getCell: (row) => (
      //     <CurrencyValue value={row.collateral} options={{ currency: 'USD' }} />
      //   ),
      //   cellAlign: 'flex-end',
      //   headerAlign: 'flex-end',
      //   sortingField: 'collateral'
      // },

      {
        header: 'Stability Fee',
        getCell: (row) => <PercentageValue value={row.duty} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'duty'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.ilk}
        rowLinkProps={{
          to: (row) => row.ilk,
          // @ts-ignore
          linkComponent: Link
        }}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton />;
}
